import dayjs from "~/config/dayjs";
import checkoutServices from "~/services/checkoutServices";

const ANTICIPATION_PAYMENT_TYPES = {
    NONE: "none",
    VALUE: "value",
    CANCELLATION_PERCENTAGE_VALUE: "first_policy_cancellation",
    CANCELLATION_FIXED_VALUE: "second_policy_cancellation",
    ANTICIPATION_PAYMENT_DISCOUNT: "third_policy_cancellation",
}

export const calculateStandaloneServicesAnticipation = async (standaloneServices, recipientId, couponCheck, coupon) => {
	if (!standaloneServices || standaloneServices.length === 0) return 0;

	try {
		let request = {
			recipient_id: recipientId,
			services: standaloneServices.map((service) => ({
				date: dayjs(service.date).utc().format(),
				service_id: service.service_id,
				professional_id: service.professional_id,
				professional: {
					price:
						service.service.servicePrice > service.professional.price
							? service.service.servicePrice
							: service.professional.price,
					pricing_type: service.professional.pricingType,
				},
			})),
		};

		if (couponCheck) {
			request.coupon_id = coupon?.coupon?.coupon_id;
		}

		const { data } = await checkoutServices.getAnticipatedAmountCheckout(request);
		return Number(data?.anticipation_payment || 0);
	} catch (error) {
		console.error("Erro ao calcular valor antecipado dos serviços avulsos:", error);
		return 0;
	}
};

const verifyAnticipationPaymentAll = (checkoutInformation, checkoutInformationPackage) => {
	const anticipation = {
        hasAnticipation: false,
        type: ANTICIPATION_PAYMENT_TYPES.NONE,
        details: {}
    }
	if (
		checkoutInformation?.anticipation_payment > 0 && checkoutInformation?.used_percentage_value
	) {
        anticipation.hasAnticipation = true;
        anticipation.type = ANTICIPATION_PAYMENT_TYPES.CANCELLATION_PERCENTAGE_VALUE;
		return anticipation;
	}

    if (checkoutInformation?.anticipation_payment > 0 && checkoutInformation?.used_fixed_value) {
        anticipation.hasAnticipation = true;
        anticipation.type = ANTICIPATION_PAYMENT_TYPES.CANCELLATION_FIXED_VALUE;
        return anticipation;
    }

    if (checkoutInformation?.anticipation_payment > 0 && checkoutInformation?.anticipation_payment_percentage) {
        anticipation.hasAnticipation = true;
        anticipation.type = ANTICIPATION_PAYMENT_TYPES.ANTICIPATION_PAYMENT_DISCOUNT;
        return anticipation;
    }

	if (
		checkoutInformationPackage?.cancellation_policy?.fixed_cancellation ||
		checkoutInformationPackage?.cancellation_policy?.percentage_cancellation
	) {
        anticipation.hasAnticipation = true;
		return anticipation;
	}
    
	return anticipation;
};

export const verifyAnticipationPayment = (checkoutInformation, checkoutInformationPackage, requireAll) => {
	if (requireAll) {
        return verifyAnticipationPaymentAll(checkoutInformation, checkoutInformationPackage);
	}
	return false;
};
